<template>
    <div>
        <component :is="componentInstance" :landing="this.landing" :stadt="this.stadt" :staedteliste="this.staedte" />
    </div>
</template>

<script>
    export default {
      data () {
        return {
          count: 0
        }
      },
      components: {},
      props: ['stadt', 'landing', 'staedte'],
      computed: {
        componentInstance () {
          const id = this.landing.wizard
          const Foo = () => import(/* webpackChunkName: "prem-profile" */ `~/components/anfragen/wizards/${id}`)
          try {
            return Foo
          } catch (e) {
            console.log('Kein wizard gefunden')
          }
        }
      }
    }
</script>
